module.exports = {
  isRegistry() {
    return this.getWindowLocation().indexOf('wedding-registry') !== -1 || this.getWindowLocation().indexOf('/registry/wedding') !== -1 || this.getWindowLocation().indexOf('/registry-') !== -1;
  },

  getWindowLocation() {
    return window.location.href;
  },
};
